import { useMutation } from "@tanstack/react-query";
import { api } from "@/lib/api";

/**
 * Auth password flows. All three hit the legacy `/auth/*` controller.
 *
 *  - forgot-password / reset-password are anonymous (no cookie needed)
 *  - change-password requires the logged-in JWT cookie
 *
 * The backend returns plain JSON strings for the reset endpoints
 * ("SUCCESS" | "INVALID_TOKEN" | "TOKEN_EXPIRED" | "RESET_FAILED" | the
 * neutral "If this email exists…" message). Callers branch on those.
 */

export function useForgotPassword() {
  return useMutation({
    mutationFn: (email: string) =>
      api.post<string>("/auth/forgot-password", { email })
  });
}

export function useResetPassword() {
  return useMutation({
    mutationFn: (vars: { token: string; newPassword: string }) =>
      api.post<string>("/auth/reset-password", {
        token: vars.token,
        newPassword: vars.newPassword
      })
  });
}

export interface ChangePasswordResult {
  success: boolean;
  message: string;
}

export function useChangePassword() {
  return useMutation({
    mutationFn: (vars: { currentPassword: string; newPassword: string }) =>
      api.post<ChangePasswordResult>("/auth/change-password", {
        currentPassword: vars.currentPassword,
        newPassword: vars.newPassword
      })
  });
}
